import React, { Component, Fragment } from "react";
import { InfoBoard, InfoBoardHelper } from "./InfoBoard";
/**
 * InfoBoard 5
 */
class InfoBoard5 extends Component {
    initialValuesLoaded = false;

    handleProductionMarginOrientationChange = event => {
        let { value } = event.target;

        this.setState(
            { productionMarginDirection: value},
            this.handleBlur
        );
    };

    handleInput = (name, event) => {
        let { value } = event.target;

        if (
            name == "numDynamicRows" &&
            !isNaN(value) &&
            parseFloat(value) > 10
        ) {
            // Limit to ten dynamic rows
            value = 10;
        }

        if (event.target.value == "") {
            this.setState({
                [name]: ""
            });
            return;
        }

        this.setState({
            [name]: isNaN(value) ? value : parseFloat(value)
        });
    };

    handleBlur = () => {
        const { mode } = this.state;

        if (mode == 'size') {
            this.handleBlurSizeMode();
        } else {
            this.handleBlurWasteMode();
        }
    };

    handleBlurSizeMode = () => {
      // width and height = material width and height
        // printWidth and printHeight = object to print
        let {
            height,
            width,
            printWidth,
            printHeight,
            bleed,
            printDirection,
            productionMargin,
            productionMarginDirection,
            objectSizeM2: lastRenderedSize
        } = this.state;

        let sheetSizeM2 = (width / 1000) * (height / 1000);
        bleed = typeof bleed == "undefined" || isNaN(bleed) ? 0 : parseFloat(bleed);

        if (parseInt(productionMargin) > 0 ) {
            if (productionMarginDirection == 'standing') {
                height -= productionMargin;
            } else {
                width -= productionMargin;
            }
        }

        let sheetFormat = width + 'x' + height;

        let wmm = parseFloat(printWidth) + bleed;
        let hmm = parseFloat(printHeight) + bleed;
        let objectSizeM2 = (wmm * hmm) / 1000000;
        let amountPerWidthStanding = 0;
        let amountPerHeightStanding = 0;
        let amountPerWidthLaying = 0;
        let amountPerHeightLaying = 0;
        let amountPerSheetStanding = 0;
        let amountPerSheetLaying = 0;
        let objectsPerRow = 0;

        if (isNaN(wmm) || isNaN(hmm)) return;

        if (hmm > 0 && wmm > 0) {
            amountPerWidthStanding = Math.floor(width / wmm);
            amountPerWidthLaying = Math.floor(height / wmm);
            amountPerHeightStanding = Math.floor(height / hmm);
            amountPerHeightLaying = Math.floor(width / hmm);
            amountPerSheetStanding =
                Math.floor(amountPerWidthStanding) *
                Math.floor(amountPerHeightStanding);

            amountPerSheetLaying =
                Math.floor(amountPerWidthLaying) *
                Math.floor(amountPerHeightLaying);
        }

        let circumference = parseFloat(
            (
                (printWidth + printWidth + printHeight + printHeight) /
                1000
            ).toFixed(4)
        );

        let circumferenceLaying =
            amountPerSheetLaying > 0
                ? parseFloat(
                    (
                        (amountPerSheetLaying *
                            (printWidth +
                                printWidth +
                                printHeight +
                                printHeight)) /
                        1000
                    ).toFixed(4)
                )
                : 0;
        let circumferenceStanding =
            amountPerSheetStanding > 0
                ? parseFloat(
                    (amountPerSheetStanding *
                        (printWidth +
                            printWidth +
                            printHeight +
                            printHeight)) /
                    1000
                ).toFixed(2)
                : 0;
        let totalM2Laying = parseFloat(
            parseFloat((amountPerSheetLaying * objectSizeM2).toFixed(4))
        );
        let totalM2Standing = parseFloat(
            parseFloat((amountPerSheetStanding * objectSizeM2).toFixed(4))
        );

        let usageLaying =
            totalM2Laying > 0
                ? Math.ceil((totalM2Laying / sheetSizeM2) * 100)
                : 0;
        let usageStanding =
            totalM2Standing > 0
                ? Math.ceil((totalM2Standing / sheetSizeM2) * 100)
                : 0;

        // Recalculate and remove decimals so we get a nicer output
        objectSizeM2 = parseFloat(parseFloat((wmm * hmm) / 1000000).toFixed(4));

        jQuery(
            ".js-totalCircumferenceStanding, .js-totalCircumferenceLaying"
        ).removeClass("js-totalCircumference");
        if (printDirection == "laying") {
            objectsPerRow = amountPerSheetStanding; // Yes, this is actually correct even though it looks to be reversed
            jQuery(".js-totalCircumferenceStanding").addClass(
                "js-totalCircumference"
            );
        } else {
            objectsPerRow = amountPerSheetLaying;
            jQuery(".js-totalCircumferenceLaying").addClass(
                "js-totalCircumference"
            );
        }

        if (
            this.initialValuesLoaded &&
            this.state.objectSizeM2 &&
            this.state.circumference &&
            (this.state.objectSizeM2 != objectSizeM2 || this.state.circumference != circumference)
        ) {
            this.clearDontRecalculateFlag = true;
        }

        this.setState(
            {
                objectSizeM2,
                sheetSizeM2: Math.round(sheetSizeM2 * 100) / 100,
                objectsPerRow,
                amountPerWidthStanding,
                amountPerHeightStanding,
                amountPerWidthLaying,
                amountPerHeightLaying,
                amountPerSheetStanding,
                amountPerSheetLaying,
                circumference,
                circumferenceLaying,
                circumferenceStanding,
                totalM2Laying,
                totalM2Standing,
                usageLaying,
                usageStanding,
                lastRenderedSize,
                sheetFormat,
                mode: 'size'
            },
            () => {
                this.updateParent();
            }
        );
    };

    handleBlurWasteMode = () => {
        let area = 0;
        // let lapsize = "";
        let usage = 0;
        let circumference = 0;
        let objectsPerRow = 0;

        let {
            height,
            printWidth,
            printHeight,
            overlap,
            bleed,
        } = this.state;

        let lastRenderedSize =
            this.state.dynRowsTotalAreaWithWaste +
            " " +
            this.state.materialArea;

        let { width: materialWidth } = this.state.originalArticle;

        printWidth = parseFloat(printWidth);
        printHeight = parseFloat(printHeight);
        height = parseFloat(height);
        materialWidth = parseFloat(materialWidth);
        overlap = isNaN(overlap) ? 0 : parseFloat(overlap);
        bleed = isNaN(bleed) ? 0 : parseFloat(bleed);

        if (!this.initialValuesLoaded) {
            this.recalculateAllDynamicRows();
            return;
        }

        // Stående = 0, liggande = 1
        let wmm = 0;
        let hmm = 0;
        let minw = materialWidth;

        wmm = parseFloat(printHeight);
        hmm = parseFloat(printWidth);

        var laps = 1;

        // Add bleed
        wmm += bleed * (laps * 2);
        hmm += bleed * 2;

        let w = wmm / 1000;
        let h = hmm / 1000;

        area = parseFloat((w * h).toFixed(4));

        circumference = Math.ceil((w * 2 + h * 2) * 10) / 10;
        let circTotal =
            Math.ceil(((Math.floor(wmm / laps) * 2 + hmm * 2) * laps) / 100) /
            10;

        // How many can we fit before we have to start on a new row?
        let usedWidthPercent = 0;
        let joint = Math.ceil(hmm * (laps - 1)) / 1000;

        let amountPerRow = Math.floor(minw / printWidth);
        amountPerRow = amountPerRow > 1 ? amountPerRow : 1;

        let printWidthWithOverlapAndBleed = printWidth;

        if (laps > 1) {
            printWidthWithOverlapAndBleed =
                printWidth + overlap * laps + bleed * laps * 2;
        } else {
            printWidthWithOverlapAndBleed += bleed * 2;
        }

        usedWidthPercent = Math.round(
            (((printWidthWithOverlapAndBleed * amountPerRow) / minw) *
                100) /
            laps
        );

        usage = isNaN(usedWidthPercent) ? "" : usedWidthPercent + "%";

        let circumferenceTotal = circTotal > 0 ? circTotal : 0;

        // if (Math.floor(wmm / laps) > 0) {
        //     lapsize = Math.floor(wmm / laps) + "x" + hmm;
        //     console.log('setting objectsPerRow in handleBlurWasteMode to '+objectsPerRow);
        //     objectsPerRow =
        //         Math.floor(minw / wmm) > 1 ? Math.floor(minw / wmm) : 1;
        // } else {
        //     lapsize = "0x" + hmm;
            objectsPerRow = 1;
        //     console.log('setting objectsPerRow in handleBlurWasteMode to '+objectsPerRow);
        // }

        let materialArea = 0;

        if (minw > 0) {
            materialArea = (minw / 1000) * h * laps;
        } else {
            materialArea = w * h;
        }

        materialArea = parseFloat(materialArea.toFixed(4));

        this.setState(
            {
                area,
                materialArea,
                laps,
                // lapsize,
                overlap,
                usage,
                circumference,
                circumferenceTotal,
                joint,
                objectsPerRow,
                mode: 'waste',
                lastRenderedSize
            },
            () => {
                this.updateParent();
            }
        );
    };

    renderDynamicRows = () => { // Only used by waste mode
        let {
            numDynamicRows,
            rows,
            dynRowsTotalCircumference,
            dynRowsTotalArea,
            dynRowsTotalAreaWithWaste
        } = this.state;
        const { isEditable } = this.props;
        const tableHeadings = [
            { name: "Antal", align: "left", width: "5%" },
            { name: "Bas i mm", align: "left", width: "10%" },
            { name: "Höjd i mm", align: "left", width: "5%" },
            { name: "Omkrets lpm", align: "left", width: "5%" },
            { name: "Yta i m2", align: "left", width: "5%" }
        ];

        if (
            "undefined" == typeof numDynamicRows ||
            isNaN(parseInt(numDynamicRows))
        ) {
            return null;
        }

        numDynamicRows = parseInt(numDynamicRows);

        while (rows.length <= 10) {
            rows.push({ amount: 0, width: 0, height: 0 });
        }

        let outputRows = [];
        for (let i = 0; i <= numDynamicRows - 1; i++) {
            outputRows.push(rows[i]);
        }

        return (
            <Fragment>
                <div className="row">
                    <div className="col-12 inputFieldsHolder">
                        {tableHeadings.map(heading => {
                            return (
                                <div
                                    key={heading.name}
                                    className={
                                        "form-group mr-1 limitSize text-" +
                                        heading.align
                                    }
                                >
                                    {heading.name}
                                </div>
                            );
                        })}
                        {isEditable && <div>&nbsp;</div>}
                    </div>
                </div>

                {outputRows.map((row, index) => (
                    <Row
                        index={index}
                        isEditable={isEditable}
                        key={index}
                        onChangeRow={(name, event) =>
                            this.handleChangeDynamicRow(index, name, event)
                        }
                        row={row}
                    />
                ))}

                <div className="row">
                    <div className="col-12 inputFieldsHolder">
                        <div className={"form-group mr-1 limitSize"} />
                        <div className={"form-group mr-1 limitSize"} />
                        <div className={"form-group mr-1 limitSize"} />
                        <div className="form-group mr-1 limitSize">
                            <label>Total omkrets lpm</label>
                            <input
                                className="form-control form-control-sm text-right form-control-hilite js-circumference js-totalCircumference"
                                value={dynRowsTotalCircumference || 0}
                                disabled
                                readOnly
                            />
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <label>
                                Total yta m<sup>2</sup>
                            </label>
                            <input
                                className="form-control form-control-sm text-right form-control-hilite js-orderedAreaM2"
                                value={dynRowsTotalArea || 0}
                                disabled
                                readOnly
                            />
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <label>
                                Total m<sup>2</sup> inkl spill
                            </label>
                            <input
                                className="form-control form-control-sm text-right form-control-hilite js-materialAreaM2"
                                value={dynRowsTotalAreaWithWaste || 0}
                                disabled
                                readOnly
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };

    handleChangeDynamicRow = (index, name, event) => {
        const { rows } = this.state;
        let thisRow = { ...rows[index] };

        thisRow[name] = event.target.value;

        rows[index] = this.calculateDynamicRowFields(thisRow);

        this.setState({ rows }, () => {
            this.calculateDynamicRowsTotal();
        });
    };

    calculateDynamicRowFields = originalRow => {
        const row = { ...originalRow };
        const width = isNaN(parseFloat(row["width"]))
            ? 0
            : parseFloat(row["width"]);
        const height = isNaN(parseFloat(row["height"]))
            ? 0
            : parseFloat(row["height"]);
        const amount = isNaN(parseFloat(row["amount"]))
            ? 0
            : parseFloat(row["amount"]);

        if (width * height * amount == 0) {
            row.circumference = 0;
            row.area = 0;
        } else {
            row.circumference = parseFloat(
                (((width * 2 + height * 2) / 1000) * amount).toFixed(4)
            );
            row.area = parseFloat(
                ((width * height * amount) / 1000000).toFixed(4)
            );
        }

        return row;
    };

    recalculateAllDynamicRows = () => {  // Only used by waste mode
        const { rows } = this.state;
        for (let i = 0; i < rows.length; i++) {
            rows[i] = this.calculateDynamicRowFields(rows[i]);
        }

        this.setState({ rows }, () => this.calculateDynamicRowsTotal());
    };

    handleWasteChange = (name, event) => {  // Only used by waste mode
        let { value } = event.target;

        this.setState(
            {
                [name]: isNaN(value) || value == "" ? "" : parseFloat(value)
            },
            () => {
                this.recalculateAllDynamicRows();
            }
        );
    };

    calculateDynamicRowsTotal = () => {  // Only used by waste mode
        const { rows, numDynamicRows } = this.state;
        const waste = isNaN(parseFloat(this.state.waste))
            ? 0
            : parseFloat(this.state.waste);
        const wasteMultiplier = isNaN(parseFloat(waste))
            ? 1
            : 1 + parseFloat(waste) / 100;
        let dynRowsTotalCircumference = 0;
        let dynRowsTotalArea = 0;

        for (let i = 0; i < numDynamicRows; i++) {
            dynRowsTotalCircumference += parseFloat(rows[i]["circumference"]);
            dynRowsTotalArea += parseFloat(rows[i]["area"]);
        }

        if (isNaN(dynRowsTotalCircumference) || isNaN(dynRowsTotalArea)) return;

        dynRowsTotalCircumference = parseFloat(
            dynRowsTotalCircumference.toFixed(4)
        );
        dynRowsTotalArea = parseFloat(dynRowsTotalArea.toFixed(4));

        let dynRowsTotalAreaWithWaste = parseFloat(
            (dynRowsTotalArea * wasteMultiplier).toFixed(4)
        );

        this.setState(
            {
                dynRowsTotalCircumference,
                dynRowsTotalArea,
                dynRowsTotalAreaWithWaste
            },
            () => {
                this.updateParent();
            }
        );
    };

    updateParent = () => {
        const { mode } = this.state;

        if (mode === 'size') {
            return this.updateParentSizeMode();
        } else if (mode === 'waste') {
            return this.updateParentWasteMode();
        }
    }

    updateParentSizeMode = () => {
        let { onChange } = this.props;
        const { data } = this.props;
        const { id } = data;
        const {
            objectSizeM2,
            objectsPerRow,
            quantity,
            lastRenderedSize,
            mode
        } = this.state;

        if ("function" !== typeof onChange) {
            console.error("Missing function onChange");
            return false;
        }

        if (!this.initialValuesLoaded) {
            onChange(id, "quantity", quantity);
            this.initialValuesLoaded = true;
        } else {
            if (lastRenderedSize != objectSizeM2) {
                onChange(id, "quantity", objectSizeM2);
            }
        }

        onChange(id, "objectsPerRow", objectsPerRow);
        onChange(id, "mode", mode);
        
        if (this.clearDontRecalculateFlag) {
            onChange(id, "clear_dont_recalculate_flag");
        }
    };

    updateParentWasteMode = () => {
        let { onChange } = this.props;
        const { data } = this.props;
        const { id } = data;
        const {
            // mode,
            quantity,
            dynRowsTotalAreaWithWaste,
            materialArea,
            objectsPerRow,
            lastRenderedSize,
            forceRecalculate
        } = this.state;

        if ("function" !== typeof onChange) {
            console.error("Missing function onChange");
            return false;
        }

        if (!this.initialValuesLoaded) {
            onChange(id, "quantity", quantity);
            this.initialValuesLoaded = true;
        } else {
            if (forceRecalculate ||
                lastRenderedSize != dynRowsTotalAreaWithWaste + " " + materialArea
            ) {
                onChange(
                    id,
                    "quantity",
                    dynRowsTotalAreaWithWaste,
                    "infoboard"
                );
                onChange(id, "clear_dont_recalculate_flag");
            }
        }

        onChange(id, "objectsPerRow", objectsPerRow);
        onChange(id, "mode", 'waste');

        if (forceRecalculate) {
            this.setState({forceRecalculate: false});
        }
    };

    populateDataSizeMode(data, extendedData) {
        if (extendedData.printHeight) {
            let printHeight = parseFloat(extendedData.printHeight);
            if (isNaN(printHeight)) {
                printHeight = 0;
            }
            data.printHeight = printHeight;
        }

        if (extendedData.printWidth) {
            let printWidth = parseFloat(extendedData.printWidth);
            if (isNaN(printWidth)) {
                printWidth = 0;
            }
            data.printWidth = printWidth;
        }

        if (extendedData.bleed) {
            let bleed = parseFloat(extendedData.bleed);
            if (isNaN(bleed)) {
                bleed = 0;
            }
            data.bleed = bleed;
        } else {
            data.bleed = 0;
        }

        if (extendedData.productionMargin) {
            let productionMargin = parseInt(extendedData.productionMargin);
            if (isNaN(productionMargin)) {
                if (this.props.isEditable) {
                    productionMargin = this.props.globalSettings.infoboard2DefaultProductionMargin;
                } else {
                    productionMargin = 0;
                }
                
            }
            data.productionMargin = productionMargin;
        } else {
            if (this.props.isEditable) {
                data.productionMargin = this.props.globalSettings.infoboard2DefaultProductionMargin;
            } else {
                data.productionMargin = 0;
            }
        }

        if (extendedData.printDirection) {
            data.printDirection = extendedData.printDirection;
        } else {
            data.printDirection = "laying";
        }

        if (extendedData.productionMarginDirection) {
            data.productionMarginDirection = extendedData.productionMarginDirection;
        } else {
            data.productionMarginDirection = "laying";
        }

        return data;
    }

    populateDataWasteMode(data, extendedData) {
        const { globalSettings } = this.props;

        if (extendedData.printHeight) {
            let printHeight = parseFloat(extendedData.printHeight);
            if (isNaN(printHeight)) {
                printHeight = 0;
            }
            data.printHeight = printHeight;
        } else {
            data.printHeight = 0;
        }

        if (extendedData.bleed) {
            let bleed = parseInt(extendedData.bleed);
            if (isNaN(bleed)) {
                bleed = globalSettings.bleed;
            }
            data.bleed = bleed;
        } else {
            data.bleed = globalSettings.bleed;
        }

        if (extendedData.numDynamicRows) {
            let numDynamicRows = parseInt(extendedData.numDynamicRows);
            if (isNaN(numDynamicRows)) {
                numDynamicRows = 1;
            }
            data.numDynamicRows = numDynamicRows;
        } else {
            data.numDynamicRows = 1;
        }

        if (extendedData.waste) {
            let waste = parseInt(extendedData.waste);
            if (isNaN(waste)) {
                waste = globalSettings.waste;
            }
            data.waste = waste;
        } else {
            data.waste = globalSettings.waste;
        }

        if (extendedData.overlap) {
            let overlap = parseInt(extendedData.overlap);
            if (isNaN(overlap)) {
                overlap = globalSettings.overlap;
            }
            data.overlap = overlap;
        } else {
            data.overlap = globalSettings.overlap;
        }

        if (!data.printDirection) {
            data.printDirection = 1;
        }
        
        if (extendedData.printWidth) {
            let printWidth = parseFloat(extendedData.printWidth);
            if (isNaN(printWidth)) {
                printWidth = 0;
            }
            data.printWidth = printWidth;
        } else {
            data.printWidth = 0;
        }

        data.rows =
            extendedData.rows && extendedData.rows.length > 0
                ? extendedData.rows
                : [];

        return data;
    }

    setMode = (mode) => {

        this.setState(
            {
                mode,
                objectSizeM2: 0, // Forces recalculation when mode is toggled,
                lastRenderedSize: 0,
                forceRecalculate: true
            },
            () => {
                if (mode === 'waste') {
                    const valueField = jQuery('li.nestable-item-'+this.state.id).find('input[name*="[rows][0][amount]"]');
                    const e = {target: {value: valueField.val()}};
                    this.handleChangeDynamicRow(0, 'amount', e);
                }

                this.handleBlur();
            }
        );
    } 

    renderFields = () => {
        const { mode } = this.state;

        if (mode === 'size') {
            return this.renderSizeModeObjectFields();
        } else if (mode === 'waste') {
            return this.renderWasteModeObjectFields();
        }
    };

    renderSizeModeObjectFields = () => {
        const {
            printDirection,
            printHeight,
            printWidth,
            objectSizeM2,
            sheetSizeM2,
            amountPerHeightLaying,
            amountPerHeightStanding,
            amountPerWidthLaying,
            amountPerWidthStanding,
            amountPerSheetLaying,
            amountPerSheetStanding,
            circumference,
            usageLaying,
            usageStanding,
            bleed,
            productionMargin,
            productionMarginDirection,
            sheetFormat
        } = this.state;

        // Yes, this is correct although it looks reversed
        let objectsPerRow =
            printDirection == "laying"
                ? amountPerSheetStanding
                : amountPerSheetLaying;

        const { isEditable } = this.props;
        const showHelpTexts = this.props.globalSettings.showHelpTexts == 1;

        const marginRotationList = [
            {
                option: "Liggande",
                value: "laying"
            },
            {
                option: "Stående",
                value: "standing"
            }
        ];

        return (
            <Fragment>
                <div className="row">
                    <div className="col-9">
                        <div className="row">
                            {isEditable && (
                            <div className="col-12 mb-4">
                                <label>Läge:</label>
                                <button className="btn btn--smallText ml-2" onClick={(e) => {e.preventDefault();}}>Storlek</button>
                                <button className="btn btn--smallText btn--smallText--outline ml-2" onClick={(e) => {e.preventDefault(); this.setMode('waste');}}>Spill</button>
                            </div>
                            )}
                            <div className="col-12 inputFieldsHolder">
                                <div className="form-group mr-1">
                                    <label>Bas i mm</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "printWidth",
                                            onChange: event =>
                                                this.handleInput("printWidth", event),
                                            onBlur: event => this.handleBlur(),
                                            value: printWidth,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            disabled
                                            readOnly
                                            value={printWidth}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1">
                                    <label>Höjd i mm</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "printHeight",
                                            onChange: event =>
                                                this.handleInput("printHeight", event),
                                            onBlur: event => this.handleBlur(),
                                            value: printHeight,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            disabled
                                            readOnly
                                            value={printHeight}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1">
                                    <label>
                                        Beställd yta m<sup>2</sup>
                                    </label>
                                    <input
                                        className="form-control form-control-sm form-control-hilite text-right js-orderedAreaM2"
                                        value={objectSizeM2}
                                        disabled
                                    />
                                </div>
                                <div className="form-group mr-1">
                                    <label>Materialets yta</label>
                                    {<input
                                            className="form-control form-control-sm form-control-hilite text-right js-materialAreaM2"
                                            disabled
                                            readOnly
                                            value={sheetSizeM2}
                                        />}
                                </div>
                                <div className="form-group mr-1">
                                    <label>Omkrets lpm</label>
                                    <input
                                        className="form-control form-control-sm form-control-hilite text-right js-totalCircumference"
                                        value={circumference}
                                        disabled
                                    />
                                </div>
                                <div className="form-group mr-1">
                                    <label>Utfall</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "bleed",
                                            onChange: event =>
                                                this.handleInput("bleed", event),
                                            onBlur: event => this.handleBlur(),
                                            value: bleed,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            disabled
                                            readOnly
                                            value={bleed}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1 ml-4">
                                    {!isEditable && productionMarginDirection == 'laying' && (<label>Liggande marginal</label>)}
                                    {!isEditable && productionMarginDirection == 'standing' && (<label>Stående marginal</label>)}
                                    {!isEditable && (<input
                                                        className="form-control form-control-sm text-right"
                                                        disabled
                                                        readOnly
                                                        value={productionMargin}
                                                    />)}
                                    
                                    {isEditable && <label>Marginalplacering</label>}
                                    {isEditable && InfoBoardHelper.renderSelect(marginRotationList, {
                                                        name: "productionMarginDirection",
                                                        onChange: event =>
                                                            this.handleProductionMarginOrientationChange(event),
                                                        value: productionMarginDirection,
                                                        style: { width: "100px" }
                                                    })}
                                </div>
                                {isEditable && 
                                <div className="form-group mr-1">
                                    <label>Marginal</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "productionMargin",
                                            onChange: event =>
                                                this.handleInput("productionMargin", event),
                                            onBlur: () => this.handleBlur(),
                                            value: productionMargin,
                                            className:
                                                "form-control form-control-sm text-right"
                                        })}
                                </div>}
                                <div className="form-group mr-1">
                                    <label>Materialets format</label>
                                    {<input
                                            className="form-control form-control-sm form-control-hilite text-right"
                                            disabled
                                            readOnly
                                            value={sheetFormat}
                                        />}
                                </div>
                            </div>
                        </div>
                        {((!isEditable && printDirection == "laying") ||
                            isEditable) && (
                                <div className="row">
                                    <div className="col-12 inputFieldsHolder">
                                        <div className="form-group mr-1 radio-no-grow-padding-right">
                                            {isEditable && <label>Liggande</label>}
                                            {!isEditable && (
                                                <React.Fragment>
                                                    <label className="mb-3">Rotation</label>
                                                    <br />
                                                    Liggande
                                    </React.Fragment>
                                            )}
                                            {isEditable &&
                                                InfoBoardHelper.renderCheckbox("", {
                                                    name: "printDirectionLaying",
                                                    value: "laying",
                                                    checked:
                                                        printDirection == "laying"
                                                            ? "checked"
                                                            : "",
                                                    onClick: () => {
                                                        this.setState(
                                                            { printDirection: "laying" },
                                                            () => {
                                                                this.handleBlur();
                                                            }
                                                        );
                                                    }
                                                })}
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/bas</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerWidthStanding}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/höjd</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerHeightStanding}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/ark</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerSheetStanding}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Nyttjande i %</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={usageStanding}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                        {InfoBoardHelper.renderHiddenInput({
                            name: "infoboardType",
                            value: 5
                        })}
                         {InfoBoardHelper.renderHiddenInput({
                            name: "mode",
                            value: "size"
                        })}
                        {InfoBoardHelper.renderHiddenInput({
                            name: "objectsPerRow",
                            value: objectsPerRow || 0
                        })}
                        {
                        (printDirection == 'standing' && 
                        InfoBoardHelper.renderHiddenInput({
                            name: "printDirection",
                            value: "standing"
                        }))
                        }
                        {
                        (printDirection == 'laying' && 
                        InfoBoardHelper.renderHiddenInput({
                            name: "printDirection",
                            value: "laying"
                        }))
                        }

                        {((!isEditable && printDirection == "standing") ||
                            isEditable) && (
                                <div className="row">
                                    <div className="col-12 inputFieldsHolder">
                                        <div className="form-group mr-1 radio-no-grow-padding-right">
                                            {isEditable && <label>Stående</label>}
                                            {!isEditable && (
                                                <React.Fragment>
                                                    <label className="mb-3">Rotation</label>
                                                    <br />
                                                    Stående
                                    </React.Fragment>
                                            )}
                                            {isEditable &&
                                                InfoBoardHelper.renderCheckbox("", {
                                                    name: "printDirectionStanding",
                                                    value: "standing",
                                                    checked:
                                                        printDirection == "standing"
                                                            ? "checked"
                                                            : "",
                                                    onClick: () => {
                                                        this.setState(
                                                            { printDirection: "standing" },
                                                            () => {
                                                                this.handleBlur();
                                                            }
                                                        );
                                                    }
                                                })}
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/bas</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerWidthLaying}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/höjd</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerHeightLaying}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Antal/ark</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={amountPerSheetLaying}
                                                disabled
                                            />
                                        </div>
                                        <div className="form-group mr-1">
                                            <label>Nyttjande i %</label>
                                            <input
                                                className="form-control form-control-sm form-control-hilite text-right"
                                                value={usageLaying}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                    <div className={(showHelpTexts ? "col-3" : "d-none")}>
                        <div className="helperTextBlock">
                            <p><b>Ark - Storlek</b><br />
                            Välj produktionensstorlek och rotera för att öka antalet eller minska spill.
                            Kontrollera utfall och produktionsmarginal på skivan. Hela arket debiteras i kalkylen och är arket för litet använd spillknappen.</p>
                            <p>Artiklar som du vill koppla dras in med flyttknappen till höger och kopplade artiklar blir gröna.</p>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };

    renderWasteModeObjectFields = () => {
        const { numDynamicRows, waste } = this.state;
        const { isEditable } = this.props;
        const showHelpTexts = this.props.globalSettings.showHelpTexts == 1;

        return (
            <Fragment>
                <div className="row">
                    <div className="col-9">
                        <div className="row">
                            {isEditable && (
                            <div className="col-12 mb-4">
                                <label>Läge:</label>
                                <button className="btn btn--smallText btn--smallText--outline ml-2" onClick={(e) => {e.preventDefault(); this.setMode('size');}}>Storlek</button>
                                <button className="btn btn--smallText ml-2" onClick={(e) => {e.preventDefault();}}>Spill</button>
                            </div>
                            )}
                            <div className="col-12 inputFieldsHolder">
                                <div className="form-group mr-1 limitSize">
                                    <label>Antal rader</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "numDynamicRows",
                                            onChange: event =>
                                                this.handleInput(
                                                    "numDynamicRows",
                                                    event
                                                ),
                                            onBlur: () => this.handleBlur(),
                                            value: numDynamicRows
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            readOnly
                                            value={numDynamicRows}
                                        />
                                    )}
                                </div>
                                <div className="form-group mr-1 limitSize">
                                    <label>Spill i %</label>
                                    {isEditable &&
                                        InfoBoardHelper.renderTextInput({
                                            name: "waste",
                                            onChange: event =>
                                                this.handleWasteChange("waste", event),
                                            value: waste
                                        })}
                                    {!isEditable && (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            readOnly
                                            value={waste}
                                        />
                                    )}
                                </div>
                                {InfoBoardHelper.renderHiddenInput({
                                    name: "infoboardType",
                                    value: 5
                                })}
                                {InfoBoardHelper.renderHiddenInput({
                                    name: "mode",
                                    value: "waste"
                                })}
                            </div>
                        </div>
                        {this.renderDynamicRows()}
                    </div>
                    <div className={(showHelpTexts ? "col-3" : "d-none")}>
                        <div className="helperTextBlock">
                            <p><b>Infoboard - Yta</b><br />
                                Infoga antal och storlek i varje rad du valt. Ändra spill i % för uppskattad spillåtgång.</p>
                            <p>Artiklar som du vill koppla till Infoboardsvärden dras in med flyttknappen.
                            Dra artikelraden till höger, den kopplas automatiskt till vald infoboardsdata och färgas grön.</p>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };

    constructor(props) {
        super(props);
        let { data } = this.props;
        const { extendedData } = this.props;

        // Populate with previously saved data
        if (
            Object.keys(extendedData).length === 0 &&
            extendedData.constructor === Object
        ) {
            // Nothing to load
            this.initialValuesLoaded = true;
        }

        data = this.populateDataSizeMode(data, extendedData);
        data = this.populateDataWasteMode(data, extendedData);

        if (extendedData.mode) {
            data.mode = extendedData.mode;
        } else {
            data.mode = 'size';
        }

        this.state = data;
    }

    componentDidMount() {
        this.handleBlur();
    }

    render() {
        const { sortIndex } = this.props;
        InfoBoardHelper.sortIndex = sortIndex;

        return <InfoBoard>{this.renderFields()}</InfoBoard>;
    }
}


class Row extends Component {
    render() {
        const { index, isEditable, row } = this.props;

        return (
            <Fragment>
                <div className="row">
                    <div className="col-12 inputFieldsHolder">
                        <div className="form-group mr-1 limitSize">
                            {isEditable &&
                                InfoBoardHelper.renderTextInput({
                                    name: "[rows][" + index + "][amount]",
                                    onChange: event =>
                                        this.props.onChangeRow("amount", event),
                                    value: row.amount
                                })}
                            {!isEditable && (
                                <input
                                    className="form-control form-control-sm text-right"
                                    readOnly
                                    value={row.amount}
                                />
                            )}
                        </div>
                        <div className="form-group mr-1 limitSize">
                            {isEditable &&
                                InfoBoardHelper.renderTextInput({
                                    name: "[rows][" + index + "][width]",
                                    onChange: event =>
                                        this.props.onChangeRow("width", event),
                                    value: row.width
                                })}
                            {!isEditable && (
                                <input
                                    className="form-control form-control-sm text-right"
                                    readOnly
                                    value={row.width}
                                />
                            )}
                        </div>
                        <div className="form-group mr-1 limitSize">
                            {isEditable &&
                                InfoBoardHelper.renderTextInput({
                                    name: "[rows][" + index + "][height]",
                                    onChange: event =>
                                        this.props.onChangeRow("height", event),
                                    value: row.height
                                })}
                            {!isEditable && (
                                <input
                                    className="form-control form-control-sm text-right"
                                    readOnly
                                    value={row.height}
                                />
                            )}
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <input
                                className="form-control form-control-sm text-right"
                                name={"[rows][" + index + "][circumference]"}
                                value={row.circumference || 0}
                                disabled
                            />
                        </div>
                        <div className="form-group mr-1 limitSize">
                            <input
                                className="form-control form-control-sm text-right"
                                name={"[rows][" + index + "][area]"}
                                value={row.area || 0}
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default InfoBoard5;
